import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb.tsx';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button.tsx';
import { ChevronLeft } from 'lucide-react';
import { useMediaQuery } from '@/hooks/use-media-query.tsx';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export const PlantBreadcrumb = ({ plant }: { plant: TPlant | undefined }) => {
  const isMobile = useMediaQuery('(max-width:640px)');

  if (!isMobile)
    return (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem className="link-underline">
            <BreadcrumbLink asChild>
              <Link to="/dashboard">Dashboard</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem className="link-underline">
            <BreadcrumbLink asChild>
              <Link to="/plants">Plants</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="flex items-center gap-1 font-semibold">
              <span>{plant?.basicDetails.name}</span>
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    );

  return (
    <Button variant="outline" asChild className="size-8 p-0">
      <Link to="/plants">
        <ChevronLeft />
      </Link>
    </Button>
  );
};

export default PlantBreadcrumb;
